<template>
    <v-snackbar
        v-model="openSnack"
        :timeout="timeout"
        color="red"
        @input="$emit('close')"
    >
        <div class="d-flex justify-space-between">
            <v-btn
                    text
                    @click="$emit('remove')"
            >
                Удалить
            </v-btn>
            <v-btn
                    text
                    @click="$emit('close')"
            >
                Отмена
            </v-btn>
        </div>

    </v-snackbar>
</template>

<script>
    export default {
        name: 'RemoveSnackbar',
        model: {
            prop: 'isOpen',
            event: 'input',
        },
        props: {
            isOpen: {
                required: true,
                type: Boolean,
            },
            snackColor: {
                required: false,
                type: String,
                default: 'info',
            },
            snackText: {
                required: false,
                type: String,
                default: '',
            },
            timeout: {
                required: false,
                type: Number,
                default: 3000,
            },
        },
        data() {
            return {
                open: this.isOpen,
            }
        },
        computed: {
            openSnack: {
                set(value) {
                    if(!value)
                        this.$emit('close')
                },
                get() {
                    return this.isOpen;
                }
            }
        },
        methods: {
            close() {
                this.open = false;
            },
        },
        watch: {
            isOpen(value) {
                this.open = value;
            },
            open(value) {
                if (!value) {
                    this.$emit('close');
                }
            },
        },
    }
</script>

<style scoped>

</style>
